<template>
  <Dialog :visible="show" @close="customClose" alert boxStyle="height:396px">
    <div class="text-whitebase mt-8">
      <div class="text-xl font-bold mb-4">
        Add {{ type === 'dao' ? 'DAOs' : 'Member' }}
      </div>

      <div
        class="
          text-whitebase text-xs
          w-full
          h-14
          border border-white-010
          rounded-lg
        "
        ref="target"
      >
        <div
          class="
            flex
            h-full
            items-center
            rounded
            relative
            bg-transparent
            px-4
            py-4
          "
        >
          <i
            class="
              iconfont
              icon-sousuo1
              flex
              items-center
              justify-center
              text-xl
            "
          ></i>
          <input
            ref="inputRef"
            class="w-full bg-transparent border-0 text-base"
            v-model="state.word"
            :placeholder="
              state.focus
                ? ''
                : type === 'dao'
                ? 'Search DAO\'s name'
                : 'Search Address/ENS'
            "
            type="text"
            @focus="state.focus = true"
          />
          <div
            v-if="state.word"
            class="
              w-6
              h-6
              flex
              justify-center
              items-center
              rounded-full
              absolute
              right-2
              top-1/2
              transform
              -translate-y-1/2
              cursor-pointer
            "
            style="background: #ffffff1a"
            @click.stop="state.word = ''"
          >
            <i class="iconfont icon-guanbi text-base"></i>
          </div>

          <div
            class="
              absolute
              -bottom-4
              left-0
              transform
              translate-y-full
              px-2
              py-4
              w-full
              rounded-lg
              font-normal
              text-left
              z-40
            "
            style="background: #2a2e33ff"
            v-if="state.focus && state.word !== ''"
          >
            <div v-if="loading && state.word != ''">
              <div v-for="(filler, i) in [1, 2, 3, 4, 5, 6]" :key="i">
                <Skeletor class="w-full mb-3 h-14 rounded-lg"></Skeletor>
              </div>
            </div>
            <UiScrollBars
              v-else-if="state.result.length > 0"
              class="w-full"
              style="max-height: 200px"
            >
              <div
                v-for="(item, i) in state.result"
                :key="i"
                class="
                  h-12
                  px-4
                  flex
                  justify-between
                  items-center
                  hover:bg-white-010
                "
                @click.stop="handleNotifFollow(i, item)"
              >
                <div class="flex gap-2 items-center">
                  <UiImg
                    class="w-8 h-8 rounded-full mr-2"
                    :src="item.logo"
                    alt="search result logo"
                  />
                  <div class="text-sm font-bold">
                    {{ formatAddress(item.name || item.address, 16) }}
                  </div>
                </div>
                <span
                  class="icon iconfont"
                  :class="{
                    'icon-shoucangxuanzhong-01 text-added': item.isAdded,
                    'icon-shoucangmoren-01': !item.isAdded,
                  }"
                ></span>
              </div>
            </UiScrollBars>

            <div v-else><div v-if="state.word !== ''">No items found</div></div>
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>
<script setup>
import Dialog from '@/components/Dialog.vue';
import { reactive, watch } from 'vue';
import { useDesktop, useReq, useReqByBool } from '@/hooks';
import { daoSearch, notifFollow, memberSearch } from '@/api/dao';
import UiScrollBars from '@/components/UiScrollbars.vue';
import UiImg from '@/components/UiImg.vue';
import { notify } from '@kyvg/vue3-notification';
import { formatAddress } from '@/utils';

const props = defineProps({
  show: Boolean,
  handleClose: Function,
  type: String,
});
const customClose = () => {
  state.word = '';
  state.result = [];
  state.focus = false;
  props.handleClose();
};
const handleNotifFollow = async (i, item) => {
  try {
    const res = await notifFollow(
      props.type,
      props.type === 'dao' ? item.daoId : item.address,
    );
    state.result[i].isAdded = !item.isAdded;
  } catch (e) {
    notify({
      type: 'error',
      text: 'Unable to process, try again later',
    });
  }
};
const state = reactive({
  word: '',
  result: [],
});

const { loadData, loading } = useReqByBool(async () => {
  let res = [];
  if (props.type === 'dao') res = await daoSearch(state.word);
  else if (props.type === 'member') res = await memberSearch(state.word);
  console.log(res);
  state.result = res;
});
const debounce = (fn, delay) => {
  let timerId;
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};
watch(
  () => state.word,
  debounce(async (val) => {
    if (val !== '') {
      await loadData();
    } else {
      state.result = [];
    }
  }, 1000),
);
</script>
<style></style>
